import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetMenuParams } from "../interface";
import LandingMenu from "design-system/src/Components/WidgetPart/LandingMenu/LandingMenu";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";

const LandingStandardMenu: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetMenuParams>((props) => {
    const { p } = props;
    const { app } = useBackboneContext();

    return (
      <LandingMenu
        title={p("title")}
        subtitle={p("subtitle")}
        linkText={p("link_text")}
        styleTemplate={p("style_template") || "standard"}
        onClick={() => app.go("listing")}
      />
    );
  });

export default LandingStandardMenu;
